import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as proyectAction from '../../store/actions/proyectAction';
import ConfirmDialog from './ConfirmDialog';
import PopUpMenu from './PopUpMenu';

class AppTopbar extends Component {
  constructor() {
    super();
    this.state = {
      expanded: false,
      visibleMenubar: false,
      visibleDialog: false,
    };
    this.onClick = this.onClick.bind(this);
    this.menu = React.createRef();
  }
  componentDidMount() {
    this.setState({ visibleMenubar: this.props.global.plantasVisibles });
  }
  static defaultProps = {
    onToggleMenu: null,
    handleChangeLanguage: null,
  };

  static propTypes = {
    onToggleMenu: PropTypes.func.isRequired,
    handleChangeLanguage: PropTypes.func.isRequired,
  };
  handleRefreshCantDias(event) {
    //console.log(event);
    this.props.refreshCantDias(event.target.value);
  }
  onClick(event) {
    this.setState({ expanded: !this.state.expanded });
    event.preventDefault();
  }
  changeLenguage(lenguage) {
    this.props.handleChangeLanguage(lenguage);
  }

  render() {
    const { t } = this.props;
    const botones = () => {
      return (
        <div
          className="floatLeft"
          style={{
            visibility: this.props.global.plantasVisibles
              ? 'visible'
              : 'hidden',
          }}
        >
          <div className="widthplus768">
            <label className="fontFamily colorBlack marginRight10px">
              {t('periodo')}
            </label>
            <select
              onChange={this.handleRefreshCantDias.bind(this)}
              value={this.props.cantDiasValue}
            >
              <option value="1">{'1 ' + t('día')}</option>
              <option value="2">{'1 ' + t('semana')}</option>
              <option value="4">{'3 ' + t('meses')}</option>
              <option value="5">{'6 ' + t('meses')}</option>
            </select>

            <ConfirmDialog
              onClickAction={() => this.props.restoreBoard(true)}
            />

            <Button
              type="button"
              className="p-link layout-profile-link"
              tooltip={t('Actualizar los datos')}
              tooltipOptions={{ position: 'left' }}
              onClick={() => this.props.refreshPanel()}
            >
              <i className="pi pi-replay"></i>
              <label className="fontFamily marginLeft10px">
                {t('Actualizar')}
              </label>
            </Button>
          </div>
        </div>
      );
    };

    const idioma = () => {
      return (
        <Fragment>
          <div className={'floatLeft'}>
            <Button
              className="p-link layout-profile-link"
              onClick={event => this.menu.current.toggle(event)}
              tooltip={t('Seleccionar Idioma')}
              tooltipOptions={{ position: 'left' }}
            >
              <i className="pi pi-fw pi-globe marginRight10px" />
              <label className="fontFamily">{t('Idioma')}</label>
            </Button>
          </div>
          <div>
            <Menu
              model={itemsBannderas()}
              popup
              ref={this.menu}
              id="popup_menu"
              className={'floatLeft right0px top50'}
            />
          </div>
        </Fragment>
      );
    };
    let itemsBannderas = () => {
      return [
        {
          label: (
            <button className="p-link layout-menu-button">
              <img
                src="assets/layout/images/EspFlag2.png"
                alt=""
                style={{ width: '35px' }}
              />
              <span className=" roboto marginLeft10px font-size20px">
                {t('Español')}
              </span>
            </button>
          ),
          command: () => this.changeLenguage('es'),
        },
        {
          label: (
            <button className="p-link layout-menu-button">
              <img
                src="assets/layout/images/UKFlag2.png"
                alt=""
                style={{ width: '35px' }}
              />
              <span className="roboto marginLeft10px font-size20px">
                {t('Ingles')}
              </span>
            </button>
          ),
          command: () => this.changeLenguage('en'),
        },
        {
          label: (
            <button className="p-link layout-menu-button">
              <img
                src="assets/layout/images/PortugalFlag.png"
                alt=""
                style={{ width: '35px' }}
              />
              <span className="roboto marginLeft10px font-size20px">
                {t('Portugues')}
              </span>
            </button>
          ),
          command: () => this.changeLenguage('por'),
        },
        {
          label: (
            <button className="p-link layout-menu-button">
              <img
                src="assets/layout/images/FranceFlag.png"
                alt=""
                style={{ width: '35px' }}
              />
              <span className=" roboto marginLeft10px font-size20px">
                {t('Frances')}
              </span>
            </button>
          ),
          command: () => this.changeLenguage('fre'),
        },
      ];
    };

    return (
      <div className="layout-topbar clearfix">
        <button
          className="p-link layout-menu-button"
          onClick={this.props.onToggleMenu}
        >
          <span className="pi pi-bars" />
        </button>
        <div className="layout-topbar-icons layout-topbar-icons-769">
          {botones()}
          {idioma()}
        </div>
        <div className="layout-topbar-icons layout-topbar-icons-768">
          <PopUpMenu
            accion={() => {
              this.props.restoreBoard(true);
            }}
            handleChangeLanguage={this.changeLenguage.bind(this)}
            refreshPanel={() => {
              this.props.refreshPanel();
            }}
            handleRefreshCantDias={this.handleRefreshCantDias.bind(this)}
            cantDiasValue={this.props.cantDiasValue}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = rootReducer => {
  return { global: rootReducer.proyect };
};
export default connect(
  mapStateToProps,
  proyectAction,
)(withTranslation('translations')(AppTopbar));
